"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArrangementRefined = void 0;
const buildArrangementRefined = (arrangement) => {
    return {
        ID: arrangement.ID,
        metadata: {
            created: arrangement.metadata.created,
            updated: arrangement.metadata.updated,
        },
        articulation: {
            ID: arrangement.articulation.ID,
            publicID: arrangement.articulation.publicID,
        },
        program: { ID: arrangement.program.ID },
        course: { ID: arrangement.course.ID },
        deliveries: arrangement.deliveriesApplied.values.map((delivery) => ({ ID: delivery })),
        subjectsAwarded: (arrangement.subjectsAwarded ?? { values: [] }).values.map((subject) => ({ ID: subject })),
        requiredCredentials: arrangement.requiredCredentials,
        status: arrangement.status,
        visibility: arrangement.visibility,
        startDate: arrangement.startDate,
        endDate: arrangement.endDate,
        successor: arrangement.successor,
        predecessor: arrangement.predecessor,
        version: arrangement.version,
        exemption: arrangement.exemption,
        activated: arrangement.activated,
        inactivated: arrangement.inactivated,
        lock: arrangement.lock,
        specified: arrangement.specified,
        unspecified: arrangement.unspecified,
        mapping: arrangement.mapping,
        institutionIdentifier: arrangement.institutionIdentifier,
        customAttributes: arrangement.customAttributes,
        additionalAdmissionCriteria: arrangement.additionalAdmissionCriteria,
        guaranteedEntryOnly: arrangement.guaranteedEntryOnly,
    };
};
exports.buildArrangementRefined = buildArrangementRefined;
//# sourceMappingURL=ArrangementRefined.js.map